var React = require('react');

function FilterArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#979797;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round;}\n"),React.createElement("g",{"id":"Design","key":1},React.createElement("g",{"id":"L1_careers-page_v4","transform":"translate(-352.000000, -2166.000000)"},React.createElement("g",{"id":"FILTER-CLOSED-02-OPEN-Copy","transform":"translate(85.000000, 2137.000000)"},React.createElement("polyline",{"id":"Path-3","className":"st0","points":"269,31 278,41 287,31 \t\t\t"}))))]);
}

FilterArrowInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 22 14","style":{"enableBackground":"new 0 0 22 14"},"xmlSpace":"preserve"};

module.exports = FilterArrowInline;

FilterArrowInline.default = FilterArrowInline;
